import { render, staticRenderFns } from "./Nakladnoy.vue?vue&type=template&id=4e018f24&scoped=true"
import script from "./Nakladnoy.vue?vue&type=script&lang=js"
export * from "./Nakladnoy.vue?vue&type=script&lang=js"
import style0 from "./Nakladnoy.vue?vue&type=style&index=0&id=4e018f24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e018f24",
  null
  
)

export default component.exports